import { a11yProps, EstadosPreagendamientoEnumChoice, hasSystemModule } from "@/shared";
import { Box, Paper, Tab, Tabs, Typography, alpha, Stack } from "@mui/material";
import { useState } from "react";
import { CustomTabPanel } from "@/erp/sale";
import { SystemModulesEnum } from "@/auth/interfaces/system-modules.enum";
import TableOrdenServicioVisita from "../../components/table-orden-servicio-visita/TableOrdenServicioVisita";
import VisitasFinalizadasTab from "../../components/visitas-finalizadas/VisitasFinalizadasTab";

export default function OrdenServicioVisitaPage() {
    const [value, setValue] = useState(0);
    // Tab "Finalizadas" gateada por el modulo de sistema (activable desde
    // Gestion de Accesos > Modulos del Sistema).
    const showFinalizadas = hasSystemModule(SystemModulesEnum.VISITAS_FINALIZADAS);

    return (
        <Box sx={{ p: { xs: 1, md: 2 } }}>
            {/* Header */}
            <Paper
                elevation={0}
                sx={{
                    mb: 3,
                    borderRadius: 3,
                    background: `linear-gradient(135deg, ${alpha("#1565c0", 0.08)} 0%, ${alpha("#42a5f5", 0.04)} 100%)`,
                    border: "1px solid",
                    borderColor: alpha("#1565c0", 0.15),
                    p: 3,
                }}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h5" fontWeight={700}>
                            Visitas técnicas
                        </Typography>
                    </Box>
                </Stack>
            </Paper>

            {/* Selector de estado */}
            <Paper
                elevation={0}
                sx={{
                    mb: 3,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                }}
            >
                <Tabs
                    value={value}
                    onChange={(_e, v) => setValue(v)}
                    sx={{
                        px: 2,
                        minHeight: 48,
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.875rem",
                            minHeight: 48,
                        },
                        "& .Mui-selected": { color: "#1565c0 !important" },
                        "& .MuiTabs-indicator": {
                            bgcolor: "#1565c0",
                            height: 3,
                            borderRadius: "3px 3px 0 0",
                        },
                    }}
                >
                    <Tab label="En Espera" {...a11yProps(0)} />
                    <Tab label="Agendado" {...a11yProps(1)} />
                    <Tab label="Recoordinado" {...a11yProps(2)} />
                    {showFinalizadas && <Tab label="Calidad de Visitas" {...a11yProps(3)} />}
                </Tabs>
            </Paper>

            {/* Tabla */}
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    overflow: "hidden",
                }}
            >
                <CustomTabPanel value={value} index={0}>
                    <TableOrdenServicioVisita estadoAgendamiento={`${EstadosPreagendamientoEnumChoice.EN_ESPERA},${EstadosPreagendamientoEnumChoice.EN_PAUSA}`}/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <TableOrdenServicioVisita estadoAgendamiento={`${EstadosPreagendamientoEnumChoice.FINALIZADO}`}/>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <TableOrdenServicioVisita estadoAgendamiento={`${EstadosPreagendamientoEnumChoice.RECORDINADO}`}/>
                </CustomTabPanel>
                {showFinalizadas && (
                    <CustomTabPanel value={value} index={3}>
                        <VisitasFinalizadasTab />
                    </CustomTabPanel>
                )}
            </Paper>
        </Box>
    );
}
